import list from "./list";
import edit from "./edit";
import users from "./users";

export default {
  namespaced: true,
  modules: { list, edit, users }
};
